<script context="module">
  export function shouldHideButton(currentUrl, button) {
    const pageOnExclusionList = import.meta.env.VITE_PAGES_TO_HIDE_DONATE?.split(",").includes(
      currentUrl
    );
    const isDonateButton =
      button.type === "donateButton" || button.contentType === "fundraiseUpElement";
    return pageOnExclusionList && isDonateButton;
  }
  import Menu from "$lib/contentTypes/Menu.svelte";
  import LinkComponent from "$lib/contentTypes/LinkComponent.svelte";
  const submenuType = (contentType) => {
    const componentMap = {
      menu: Menu,
      linkComponent: LinkComponent
    };
    return componentMap[contentType];
  };
</script>

<script>
  import { page } from "$app/stores";
  export let data;
  export let labelledby = "";

  let clazz = "";
  export { clazz as class };

  /*
    `productMenuLink` is used for direct links that are meant to match the style of
    dropdown menuTriggers in the header.
  */
  const shoudlApplyDropdownMenuStyle = (menuItem) => {
    return menuItem.contentType === "menu" || menuItem.type === "productMenuLink";
  };
</script>

<div class="lg:max-w-screen-lg mx-auto">
  <ul
    class="list-none flex flex-col lg:gap-8 lg:flex-row relative lg:justify-between lg:items-center {clazz}"
    aria-labelledby={labelledby}
  >
    {#each data as menuItem}
      <li
        class="place-items-center lg:flex"
        class:flex-1={!shoudlApplyDropdownMenuStyle(menuItem)}
        class:hidden={!shoudlApplyDropdownMenuStyle(menuItem)}
        class:justify-end={menuItem.type === "donateButton" ||
          menuItem.type === "primaryButton" ||
          menuItem.contentType === "fundraiseUpElement"}
        class:invisible={shouldHideButton($page.url?.pathname, menuItem)}
      >
        <svelte:component
          this={submenuType(menuItem.contentType)}
          on:click
          on:urlDispatch
          data={menuItem}
          id={menuItem?.sys?.id ? `header-menu-row-${menuItem.sys.id}` : ""}
        />
      </li>
    {/each}
  </ul>
</div>
